/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-danger */
/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { Dropdown, Empty } from 'antd'
import { useTranslation } from 'contexts/Localization'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import useGetNotification from 'state/notification/hooks/useGetNotification'
import usePutReadAllNotification from 'state/notification/hooks/usePutReadAllNotification'
import usePutReadNotification from 'state/notification/hooks/usePutReadNotification'
import styled from 'styled-components'
import { Link } from 'widgets'
import Noti from 'widgets/Svg/Icons/Noti'
import Noti2 from 'widgets/Svg/Icons/Noti2'
import Setting from 'widgets/Svg/Icons/Setting'

const WrappMenuNoti = styled.div`
  margin: 0 0 0 24px;

  &.is-scroll {
    .box-icon {
      svg {
        path {
          &:nth-child(1),
          &:nth-child(2) {
            fill: #000;
          }
        }
      }
    }
  }

  .box-icon {
    position: relative;
    cursor: pointer;

    svg {
      path {
        transition: 0.2s;
      }
    }

    &:hover,
    &.hover {
      svg {
        path {
          transition: 0.2s;

          &:nth-child(1),
          &:nth-child(2) {
            fill: #006dfe;
          }
        }
      }
    }
  }

  &:not(.is-scroll) {
    .box-icon {
      svg {
        &:nth-child(2) {
          position: absolute;
          left: 0;
          top: 0;
          filter: blur(5px);
          opacity: 0;
          z-index: -1;
          transition: 0.2s;

          path {
            fill: #fff;
          }
        }

        path {
          &:nth-child(1),
          &:nth-child(2) {
            fill: #fff;
          }
        }
      }

      &:hover,
      &.hover {
        svg {
          opacity: 1;
        }
      }
    }
  }
`

const CustomeMenuNoti = styled.div`
  position: relative;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 1px 0px 10px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  border-radius: 10px;
  width: 333px;
  padding: 12px 5px 8px 14px;

  &.active {
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      z-index: 1;
    }
  }

  .content-noti {
    min-height: 179px;
    max-height: 70vh;
    overflow: auto;
    padding-right: 6px;

    .content-noti-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 11px;

      p {
        font-weight: 700;
        font-size: 24px;
        line-height: 30px;
        color: #000000;
      }
    }

    .content-noti-actions {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      button {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        width: 80px;
        max-width: 100%;
        min-height: 25px;
        border-radius: 5px;
        border: none;
        cursor: pointer;
        color: #000000;
        background: transparent;
        border: 1px solid #000000;

        &.active {
          color: #ffffff;
          background: #006dfe;
          border: 1px solid #006dfe;
        }

        &:not(:last-child) {
          margin-right: 5px;
        }
      }
    }

    .content-noti-body {
      .wrap-item-noti {
        &:not(:last-child) {
          margin-bottom: 12px;
        }

        .wrap-item-noti-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 7px;

          p {
            font-family: 'Inter';
            font-style: normal;

            &:nth-child(1) {
              font-weight: 700;
              font-size: 14px;
              line-height: 17px;
              color: #000000;
            }

            &:nth-child(2) {
              font-weight: 400;
              font-size: 12px;
              line-height: 15px;
              color: #006dfe;
              cursor: pointer;
            }
          }
        }

        .wrap-item-noti-body {
          .item-noti {
            position: relative;
            display: flex;
            background: rgba(239, 239, 239, 0.8);
            border-radius: 5px;
            padding: 5px 8px;
            cursor: pointer;
            padding-right: 20px;

            &.unread {
              background: #efefef;

              &:after {
                content: '';
                position: absolute;
                top: 50%;
                right: 8px;
                transform: translateY(-50%);
                width: 7px;
                height: 7px;
                border-radius: 50%;
                background: #006dfe;
              }

              .item-noti-content {
                p {
                  color: #000000;
                  opacity: 1;

                  &.noti-content-time {
                    color: #006def;
                  }
                }
              }
            }

            &:not(:last-child) {
              margin-bottom: 5px;
            }

            .item-noti-image {
              width: 40px;
              margin-right: 9px;

              img {
                width: 100%;
              }
            }

            .item-noti-content {
              flex: 1;
              margin-top: -2px;

              p {
                font-family: 'Inter';
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 15px;
                color: rgba(109, 109, 109);
                opacity: 0.6;

                &.noti-content-time {
                  font-size: 8px;
                  line-height: 10px;
                  color: rgba(109, 109, 109);
                }

                span {
                  display: table-cell;
                }

                strong {
                  display: inline-table;
                  margin-top: -2px;
                }
              }
            }
          }
        }
      }
    }
  }
`

const CustomeMenuActionNoti = styled.div`
  background: #ffffff;
  box-shadow: 1px 0px 2px rgba(0, 0, 0, 0.79);
  border-radius: 10px;
  padding: 8px 12px;
  width: 303px;
  margin-top: 8px;

  ul {
    list-style-type: none;

    li {
      &:not(:last-child) {
        margin-bottom: 2px;
      }

      button {
        display: flex;
        align-items: center;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        background: transparent;
        border: none;
        padding: 0;
        width: 100%;
        text-align: left;
        cursor: pointer;

        svg {
          width: 16px;
          padding: 0 2px;
          margin-right: 4px;
        }
      }

      &:nth-child(1) {
        button {
          color: #006dfe;

          img {
            width: 16px;
            margin-right: 4px;
          }
        }
      }
    }
  }
`

const menuActionNoti = (t, handleMakeAllAsRead) => (
  <CustomeMenuActionNoti>
    <ul>
      <li>
        <button type="button" onClick={handleMakeAllAsRead}>
          <img src="/images/notification/checked.svg" alt="Mask all as read" /> {t('Mask all as read')}
        </button>
      </li>
      <li>
        <button type="button">
          <Setting /> {t('Setting')}
        </button>
      </li>
      <li>
        <Link href="/notification">
          <button type="button">
            <Noti2 /> {t('Go to Notifications page')}
          </button>
        </Link>
      </li>
    </ul>
  </CustomeMenuActionNoti>
)

const menuNoti = (
  t,
  visibleDropdownAction,
  handleVisibleContentChange,
  refContainerDropdown,
  dataNotification,
  handleRead,
  handleGetReadAll,
  handleGetUnread,
  handleMakeAllAsRead,
  controlNotification,
  setControlNotification,
) => (
  <CustomeMenuNoti className={`cart-empty ${visibleDropdownAction ? 'active' : ''}`}>
    <div className="content-noti">
      <div className="content-noti-header">
        <p>{t('Notifications')}</p>

        <Dropdown
          overlay={menuActionNoti(t, handleMakeAllAsRead)}
          placement="bottomRight"
          trigger={['click']}
          open={visibleDropdownAction}
          onOpenChange={handleVisibleContentChange}
          getPopupContainer={() => refContainerDropdown.current}
        >
          <img style={{ cursor: 'pointer' }} src="/images/icons/dots.svg" alt="" />
        </Dropdown>
      </div>

      <div className="content-noti-actions">
        <button
          type="button"
          className={controlNotification === 0 ? 'active' : ''}
          onClick={() => {
            handleGetReadAll()
            setControlNotification(0)
          }}
        >
          {t('All')}
        </button>
        <button
          type="button"
          className={controlNotification === 1 ? 'active' : ''}
          onClick={() => {
            handleGetUnread()
            setControlNotification(1)
          }}
        >
          {t('Unread')}
        </button>
      </div>

      <div className="content-noti-body">
        {dataNotification?.[0]?.children.length > 0 || dataNotification?.[1]?.children.length > 0 ? (
          dataNotification?.map(
            (item, index) =>
              item.children.length > 0 && (
                <div className="wrap-item-noti" key={`noti-${item.id}`}>
                  <div className="wrap-item-noti-header">
                    <p>{item.category}</p>
                    <p>
                      <Link href="/notification">{index === 0 && 'See all'}</Link>
                    </p>
                  </div>

                  <div className="wrap-item-noti-body">
                    {item.children.map((children) => (
                      <div
                        key={children?.content}
                        className={`item-noti ${children.unRead ? 'unread' : ''}`}
                        onClick={() => {
                          if (children.unRead) handleRead(children)
                        }}
                      >
                        <div className="item-noti-image">
                          <img src={children.imageUrl} alt={children.content} />
                        </div>
                        <div className="item-noti-content">
                          <div dangerouslySetInnerHTML={{ __html: children.title }} />
                          <p className="noti-content-time">{moment(children.createdAt).format('HH:mm | YYYY-MM-DD')}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ),
          )
        ) : (
          <Empty />
        )}
      </div>
    </div>
  </CustomeMenuNoti>
)

const MenuNoti = ({ isScroll, refContainerDropdown }) => {
  const { t } = useTranslation()
  const [visibleDropdown, setVisibleDropdown] = useState(false)
  const [visibleDropdownAction, setVisibleDropdownAction] = useState(false)
  const [controlNotification, setControlNotification] = useState<number>(0)

  const [getNotification] = usePutReadNotification()
  const [getReadAllNotification] = usePutReadAllNotification()
  const [getDataNotification] = useGetNotification(false)

  const [parameGetNotification, setParameGetNotification] = useState<any>({
    isGetAll: true,
    unRead: null,
    active: false,
  })

  const { listNotification } = useSelector((state: any) => state.notification)

  const handleVisibleChange = (flag: boolean) => {
    setVisibleDropdown(flag)
  }

  const handleVisibleContentChange = (flag: boolean) => {
    setVisibleDropdownAction(flag)
  }

  const handleRead = (item) => {
    getNotification(item.id)
  }

  const handleGetReadAll = () => {
    setParameGetNotification((prev) => ({
      ...prev,
      unRead: undefined,
      active: true,
    }))
  }

  const handleGetUnread = () => {
    setParameGetNotification((prev) => ({
      ...prev,
      unRead: true,
      active: true,
    }))
  }

  useEffect(() => {
    if (parameGetNotification.active) {
      getDataNotification(parameGetNotification)
    }
  }, [getDataNotification, parameGetNotification])

  const handleMakeAllAsRead = () => {
    getReadAllNotification()
  }

  return (
    <>
      <WrappMenuNoti className={isScroll ? 'is-scroll' : ''}>
        <Dropdown
          overlay={menuNoti(
            t,
            visibleDropdownAction,
            handleVisibleContentChange,
            refContainerDropdown,
            listNotification,
            handleRead,
            handleGetReadAll,
            handleGetUnread,
            handleMakeAllAsRead,
            controlNotification,
            setControlNotification,
          )}
          placement="bottom"
          trigger={['click']}
          open={visibleDropdown}
          onOpenChange={handleVisibleChange}
          getPopupContainer={() => refContainerDropdown.current}
        >
          <div className={`box-icon ${visibleDropdown ? 'hover' : ''}`}>
            <Noti />
            {!isScroll && <Noti />}
          </div>
        </Dropdown>
      </WrappMenuNoti>
    </>
  )
}

export default MenuNoti
